/* projects/shared/src/lib/components/generic-multi-autocomplete/generic-multi-autocomplete.component.scss */
:host {
  display: flex;
  min-width: 0;
  width: 100%;
}
mat-form-field {
  margin-bottom: 0 !important;
  min-width: 0;
  width: 100%;
}
mat-chip-grid {
  max-width: 100%;
}
input {
  min-width: 8rem;
}
@media (max-width: 599.98px) {
  input {
    min-width: 4rem;
    width: 100%;
  }
}
/*# sourceMappingURL=generic-multi-autocomplete.component.css.map */
